import PaymentDetailApp from "Payment/Detail/app";
import PaymentListApp from "Payment/List/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const paymentRoute: RouteObject = {
  path: "payment",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: PaymentListApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: PaymentDetailApp,
  }]
};